<template>
  <a>
    <img :src="require(`@/assets/img/${image}`)" class="image" />
    <p class="name">
      {{ name }}
    </p>
    <p class="date">
      {{ date }}
    </p>
    <p class="catch">
      {{ catchTxt }}
    </p>
  </a>
</template>

<script>
export default {
  props: {
    image: String,
    name: String,
    date: String,
    catchTxt: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/upgradePlan/tripPlan.scss";
</style>
